import { get, post, put, Delete } from "../axios";

// 协议设置-修改
export const agreementUpdate = (params) =>
  put("/web/system/agreement/update", params);

// 协议设置-查看
export const agreementView = (params) => get(`/web/system/agreement/view`);
